import { TabList, Tabs } from "./Tabs";

import type { TabListProps } from "./TabList";

export interface TabNavigationProps {
  children?: TabListProps["children"];
}

export function TabNavigation({ children }: TabNavigationProps) {
  return (
    <Tabs>
      <TabList role="navigation">{children}</TabList>
    </Tabs>
  );
}
